// extracted by mini-css-extract-plugin
module.exports = {"trigger":"customCmcDropdown_trigger__owl9J","menu":"customCmcDropdown_menu__Ti0tF"};